<template>
  <footer id="a-footer">
    <div class="footer-copy">
      <span>
        Adtelier &copy; . IT10556780962 .
        <a
          target="_blank"
          :href="lang === 'en' ? 'https://www.iubenda.com/privacy-policy/72080415' : 'https://www.iubenda.com/privacy-policy/98087786'"
          data-cta
        >
          <u>Privacy</u>
        </a> .
        <a
          target="_blank"
          :href="lang === 'en' ? 'https://www.iubenda.com/privacy-policy/72080415/cookie-policy' : 'https://www.iubenda.com/privacy-policy/98087786/cookie-policy'"
          data-cta
        >
          <u>Cookies</u>
        </a>
      </span>
    </div>
    <div class="footer-nav">
      <ul>
        <li>
          <router-link class="footer-next" data-transition="next" data-cta :to="`${ link }`">
            <div class="side">Next . {{ page }}</div>
            <div class="side">Next . {{ page }}</div>
          </router-link>
        </li>
        <li>
          <router-link
            class="footer-contact"
            data-transition="contact"
            data-cta
            :to="`/${lang}/${lang === 'it' ? 'contatti' : 'contact'}`"
          >
            <template v-if="lang === 'it'">
              <div class="side">Contattaci</div>
              <div class="side">Contattaci</div>
            </template>
            <template v-else>
              <div class="side">Contact Us</div>
              <div class="side">Contact Us</div>
            </template>
          </router-link>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
import { app } from '@/utils/store';
import Footer from './footer';

let footer;

export default {
  props: ['page', 'link'],
  data() {
    return {
      lang: app.language,
    };
  },
  mounted() {
    setTimeout(() => {
      footer = new Footer();
      footer.init();
    }, 1250);
  },
};
</script>
